import { FC } from 'react';
import { OptionsList } from './options-list';

interface INeighborhoodOptionProps {
  neighborhoodId: string | number;
}

export const NeighborhoodOptionPage: FC<INeighborhoodOptionProps> = ({ neighborhoodId }) => {
  return (
    <>
      <OptionsList neighborhoodId={neighborhoodId} />
    </>
  );
};
